import Backbone from 'lib/backbone';
import templates from 'generated/compiled_handlebars_templates';
import fastactionConfig from 'app/fastactionConfig';
import user from 'app/models/FastActionUser';
import FastActionView from 'app/views/FastActionView';
import authPopups from 'app/authPopups';
import currency from 'app/views/helpers/currency';
import telemetry from 'app/views/helpers/telemetry';
import cookieConsentConfig from 'app/CookieConsentConfiguration';
import ActionTagConfig from 'config/actionTagConfig';

var $ = Backbone.$,
  _ = Backbone._,
  userView = null,
  fastActionEnabled = null,
  fastActionConnectionFailure = false,
  updateMyProfile = false,
  nologin = false,
  loggedIn = false,
  kiosk = false,
  fastActionHtml = '<i>Fast</i><b>Action</b>',
  FASTACTION_PROFILE_BLOCK_HTML = '<div class="fastaction-block"></div>',
  autoProcessPostData = null;

function isNotEnabled() {
  return !ActionTagConfig.FASTACTION_ENABLED
    || !fastActionEnabled
    || (!loggedIn && !!fastActionConnectionFailure);
}

function hasPayment(def) {
  return _(def).map('name').includes('PaymentInformation');
}

// cc block should be its own view
function swapCreditCardBlock(fastActionUser) {
  if (isNotEnabled()) {
    return;
  }
  // This is kind of ugly, but it can fortunately go away when the fastAction plugin's
  // functionality is wholly subsumbed into NVTag proper.
  _.each(window.nvtag.tags, function (tag) {
    var formview = tag.formviews.current;
    formview.setFastActionState(fastActionUser);
  });
}

function buildConfirmAccountModal(currentFormView, fastActionUser, onConfirm) {
  const displayValues = fastActionUser.getCardDisplayValues();
  const fastActionProfileData = fastActionUser.getProfileData();

  // Build contact info
  var userName = '';
  if (fastActionProfileData.FirstName) {
    userName = fastActionProfileData.FirstName;
    if (fastActionProfileData.LastName) {
      userName += ' ' + fastActionProfileData.LastName[0];
      if (fastActionProfileData.LastName.length > 1) {
        userName += '.';
      }
    }
  }

  var userLocationDetails = [];
  if (fastActionProfileData.City) {
    userLocationDetails.push(fastActionProfileData.City);
  }

  if (fastActionProfileData.StateProvince) {
    userLocationDetails.push(fastActionProfileData.StateProvince);
  }

  var userLocation = '';
  if (userLocationDetails.length) {
    if (userName) {
      userLocation += ' \u2022 ';
    }
    userLocation += userLocationDetails.join(', ');
  }

  var userCardDigits = '';
  if (displayValues && displayValues.ccType) {
    userCardDigits += ' \u2022 ';
  }
  userCardDigits += '****' + (displayValues && displayValues.ccLastFour ? displayValues.ccLastFour : '');

  var resources = currentFormView.options.form_definition.resources;

  var currentFormVals = currentFormView.val();
  const faUrl = fastactionConfig.urls.base();

  currentFormView.$el.find('#fastaction-confirm-account').remove();
  currentFormView.$el.append(templates.fa_confirm_account_modal({
    text: {
      UserName: userName,
      UserLocation: userLocation,
      UserCardType: displayValues ? displayValues.ccType : '',
      UserCardDigits: userCardDigits,
      YesCompleteDonation: resources.fill(resources.PrimaryResources.YesCompleteDonation, currency.format(currentFormVals.Amount))
    },
    ShowContactDetails: userName || userLocation,
    ShowCardDetails: !!(
      displayValues &&
      (
        (typeof displayValues.ccType === 'string' && displayValues.ccType !== '') ||
        (typeof displayValues.ccLastFour === 'string' && displayValues.ccLastFour !== '')
      )
    ),
    fastactionUrl: faUrl,
    resources: resources
  }));
  $('a.fastaction-confirm-account-button').unbind()
    .click(onConfirm);
}

// As far as I know clients don't use this and it's only here for ease of debugging
window.nvtag.user = user;

var FastAction = (function () {
  // To handle auto-submit logic, we need to know when the form has rendered, when the fastaction databag is available,
  //  and when the fastaction profile is ready and logged in
  var deferredRender = $.Deferred();
  var deferredFastActionFill = $.Deferred();
  var deferredFastActionProfileReady = $.Deferred();
  var deferredFormdefSync = $.Deferred();
  var deferredFastActionCookies = $.Deferred();

  // FastAction will get attached to the first form on the page to trigger a sync event
  // Multiple forms on the same page are not handled gracefully, especially with autoprocessing links
  window.nvtag.once('sync:formdef', deferredFormdefSync.resolve);

  cookieConsentConfig.on('change:functionalAccepted', deferredFastActionCookies.resolve);

  if (cookieConsentConfig.areFunctionalCookiesAccepted()) {
    deferredFastActionCookies.resolve();
  }

  // Fetch fastaction information once the form definition has loaded and fastAction cookies
  // are either accepted or we are not in Cookie Consent Mode
  $.when(deferredFormdefSync, deferredFastActionCookies).done(function (formView) {
    var formModel = formView.model;
    if (formModel.get('fastAction')) {
      var metadata = formModel.get('metadata');
      var autoFastAction = formModel.get('autoFastAction');
      var qs = formView.options.query_string;

      user.set('tokenPool', metadata.fastActionTokenPool);

      // We'll attempt to autoprocess the form if a token is present, and its enabled on the form definition
      const attemptAutoProcess = autoFastAction && formView.isFirstForm() && qs.tknfa && formView.contactMode !== 'org';

      // If the form def has autoprocessing enabled, set it up to autoprocess
      // once all the necessary information has been loaded.
      if (attemptAutoProcess) {
        $.when(deferredRender, deferredFastActionProfileReady, deferredFastActionFill)
          .done(function () {
            if (user.getSavedCardMode() !== null) {
              processAutoSubmit(formView, qs.tknfa, qs);
            }
          });
      }

      // When the form definition tells us to, log in to the specified fastaction profile
      // OA includes `metadata.fastActionLoginId` in the formDef if the url includes a contact
      // smartlink and that smartlink wins in OA's formDef fill precedence logic
      if (metadata && metadata.fastActionLoginId) {
        var fastActionFormDefId = metadata.fastActionLoginId;

        var fastActionLogin = function fastactionLogin() {
          user.loginAndFetchProfile(fastActionFormDefId)
            .then(function () {
              deferredFastActionProfileReady.resolve();
            });
        };

        // When the supporter says this isn't them, we need to reload the page in a way that
        // (1) busts the cache in OA
        // (2) doesn't try to autoprocess
        // The simplest approach here is just to replace the 'tknfa' parameter with a 'notme' flag
        // Since IE11 doesn't have any URL helpers, use regex to do the replacment
        var fastActionNotMe = function fastActionNotMe() {
          deferredFastActionProfileReady.reject();
          // Clear the FastActionUser model but do not logout: we want to keep FastActionSessionId in localStorage
          // or OA 1st party cookie. if the supporter was already logged into a different FastAction profile, they
          // will be logged into that profile if they hit "not me" on the modal
          user.clear();
          var re = /tknfa=[^&#]*/;
          var url = window.location.href;
          var newUrl = url.replace(re, 'notme=1');
          window.location = newUrl;
        };

        if (attemptAutoProcess) {
          // Wait for the FastAction profile info to load. if it fails to load, do nothing
          // If the FastAction profile info has a saved card, show the confirmation modal
          // If confirmed, login as that fastaction profile; otherwise, clear out info as necessary
          // If the FastAction profile has no saved card, just login as that profile
          var deferredFetchProfile = user.fetchProfileWithoutLoggingIn(fastActionFormDefId);

          $.when(deferredFastActionFill, deferredFetchProfile)
            .then(function () {
              // If everything is ready, check we have a saved card or vgs fallback and then confirm its usage, otherwise proceed with a normal login
              if (user.getSavedCardMode() !== null) {
                _.defer(function () {
                  confirmFastActionUser(formView, user)
                    .then(fastActionLogin, fastActionNotMe);
                });
              } else {
                fastActionLogin();
              }
            });
        } else {
          fastActionLogin();
        }
      } else {
        user.fetch()
          .then(function () {
            deferredFastActionProfileReady.resolve();
          });
      }
    }
  });

  // Submit the form after autoprocessing confirmation
  function processAutoSubmit(formView, token, qs) {
    formView.trigger('preAutoProcess');
    autoProcessPostData = {
      token: token,
      qs: qs
    };
    formView.focusOnNextRequiredValueOrSubmit({
      shouldRenderFeedback: true,
      submissionType: 'fastActionAutoSubmit'
    });
  }

  // Open the account confirmation modal, and return a promise that represents the users confirmation
  // Rejects the promise if the user does not confirm and closes the modal
  function confirmFastActionUser(formView, fastActionUser) {
    var deferredConfirmation = $.Deferred();
    var hasConfirmed = false;

    function onConfirm() {
      hasConfirmed = true;
      deferredConfirmation.resolve();
    }

    buildConfirmAccountModal(formView, fastActionUser, onConfirm);
    window.location.hash = '#fastaction-confirm-account';

    // The next time the modal hide event is triggered, if the user didn't confirm, they must have rejected
    // We can't listen for a specific rejection because the modal library doesn't let you run a callback when the user hits 'ESC'
    $(document).one('cssmodal:hide', function () {
      if (!hasConfirmed) {
        deferredConfirmation.reject();
      }
    });

    return deferredConfirmation.promise();
  }

  user.on('syncError', function () {
    fastActionConnectionFailure = true;
  });

  user.on('change:id', function (user, id) {
    if (id) {
      $('.at input[name="updateMyProfile"]').prop('checked', true);
      loggedIn = true;
      fastActionConnectionFailure = false;
    } else {
      loggedIn = false;

      _.each(window.nvtag.tags, function (tag) {
        var formview = tag.formviews.current;
        var resources = formview.options.form_definition.resources;
        formview.clear().fill();
        if (nologin) {
          formview.$('.updateMyProfileSection').show().find('.text').html(
            resources.fill(resources.PrimaryResources.RememberMeFastActionNextTime, fastActionHtml));
        } else {
          formview.$('.updateMyProfileSection').hide();
        }
        if (formview.multistep && formview.getStepIndex()) {
          formview.setStep(1);
        }
      });
    }
  });

  function FastAction() {
  }

  FastAction.prototype.alterFormDefinition = function (args) {
    nologin = !!args.form_definition.fastActionNologin;
    kiosk = !!args.query_string.kiosk;
    fastActionEnabled = !kiosk && !!args.form_definition.fastAction;
    var showUpdateMyProfile = !args.form_definition.hideUpdateMyFastActionProfile;

    // Only show the FastAction block if this form is FastAction enabled
    if (isNotEnabled()) {
      return args;
    }

    var fastActionBlock = {
      type: 'markup',
      // This should probably be updated to use the View's markup rather
      // than generating a new one. This breaks event binding.
      markup: FASTACTION_PROFILE_BLOCK_HTML,
      name: 'FastAction'
    };
    // Unshift to push this in as the first item
    args.form_definition.form_elements.unshift(fastActionBlock);

    var resources = args.form_definition.resources;

    if (showUpdateMyProfile) {
      var updateMyProfile = {
        type: 'markup',
        // This should probably be updated to use the View's markup rather
        // than generating a new one. This breaks event binding.
        /*jshint -W101 */
        markup: '<div class="updateMyProfileSection" style="display: none"><label style="display:inline;"><input type="checkbox" name="updateMyProfile" checked="checked"><span><span class="text">' + resources.fill(resources.PrimaryResources.UpdateMyFastActionProfile, fastActionHtml) + '</span></span></label></div>',
        /*jshint +W101 */
        name: 'UpdateMyProfile',
        contactMode: 'person'
      };
      var fieldsets = _(args.form_definition.form_elements).filter(function (def) {
        return def.hasOwnProperty('children');
      });
      var fieldset = null;
      if (args.form_definition.type === 'EventForm') {
        fieldset = fieldsets.head();
      } else {
        fieldset = fieldsets.find({ name: 'PaymentInformation' }) || fieldsets.head();
      }
      if (fieldset) {
        fieldset.children.push(updateMyProfile);
      }
    }

    // See if user is logged in
    return args;
  };

  FastAction.prototype.postFill = function (args) {
    if (isNotEnabled()) {
      return args;
    }
    var formView = args.view,
      source = args.fill_source,
      dict = args.fill_dict;

    // If we have a populated fastaction fill dictionary, indicate that fastaction fill has ocurred
    if (source === 'FastAction' && dict) {
      formView.clearFeedback();
      deferredFastActionFill.resolve();
    }

    this.adjustCheckbox(formView);

    return args;
  };

  FastAction.prototype.adjustCheckbox = function (view) {
    var resources;
    if (view.options.form_definition &&
      view.options.form_definition.resources) {
      resources = view.options.form_definition.resources;
    } else if (view.options.formview &&
      view.options.formview.options.form_definition &&
      view.options.formview.options.form_definition.resources) {
      resources = view.options.formview.options.form_definition.resources;
    }
    if (!resources) {
      return;
    }

    var loginLabel = resources.fill(resources.PrimaryResources.UpdateMyFastActionProfile, fastActionHtml);
    if (nologin) {
      var label = view.$('.updateMyProfileSection').show().find('.text');
      if (loggedIn) {
        label.html(loginLabel);
      } else {
        label.html(resources.fill(resources.PrimaryResources.RememberMeFastActionNextTime, fastActionHtml));
      }
    } else {
      if (loggedIn) {
        view.$('.updateMyProfileSection').show().find('.text').html(loginLabel);
      } else {
        view.$('.updateMyProfileSection').hide();
      }
    }

    if (!cookieConsentConfig.areFunctionalCookiesAccepted()) {
      view.$('.updateMyProfileSection').hide();
    }
  };

  FastAction.prototype.postRender = function (args) {
    if (isNotEnabled()) {
      return args;
    }

    $(args.options.el).find('input[name="updateMyProfile"]').on('change', function (e) {
      e.stopImmediatePropagation();
    });

    // TODO: Remove this args hack.  It should always exist; this is just a temporary work-around for a Drupal bug.
    if (args && args.thank) {
      $(args.options.el).prepend(FASTACTION_PROFILE_BLOCK_HTML);
    }
    // initialize once
    if (!userView) {
      userView = new FastActionView({
        el: '.fastaction-block',
        model: user,
        nologin: nologin,
        resources: args.form_definition.resources || {}
      });
    }

    if (user.getSavedCardMode() !== null) {
      swapCreditCardBlock(user);
    }

    user.on('change:savedCard change:vgsFallback', function () {
      swapCreditCardBlock(user);
    });

    deferredRender.resolve();
    return args;
  };

  // Called after successful form submission, before navigation to confirmation page
  // This is where we update FastAction profile with the submission data
  FastAction.prototype.preSegue = function (args) {
    // args: { response, postVals, formdef, confirmation }

    // Determine if we should update/create FastAction profile
    if (!updateMyProfile || isNotEnabled() || !cookieConsentConfig.areFunctionalCookiesAccepted() || args?.confirmation?.confirmationActionType === 'Lightbox') {
      return args;
    }

    var shouldUpdate = loggedIn;
    var shouldCreate = !loggedIn && nologin;

    if (!shouldUpdate && !shouldCreate) {
      return args;
    }

    // Build request data from form and OA response.
    // Shape matches FastActionCreateProfileRequest (create/update client): profile-only,
    // profile + saved payment, or profile + payment + transaction — omit unused keys.
    var profileData = this.buildProfileDataFromForm(args.postVals);
    const paymentData = this.buildPaymentDataFromOAResponseAndForm(args.response, args.postVals);
    var transactionData = this.buildTransactionDataFromOAResponse(args.response, args.formdef);

    let request;
    if (transactionData && paymentData) {
      request = {
        profile: profileData,
        payment: paymentData,
        transaction: transactionData,
        options: { saveCreditCard: true }
      };
    } else if (paymentData) {
      request = {
        profile: profileData,
        payment: paymentData,
        options: { saveCreditCard: true }
      };
    } else {
      request = { profile: profileData };
    }

    if (shouldUpdate) {
      user.updateProfileAfterSubmission(request)
        .fail(function(model, response) {
          telemetry.trackException({
            exception: new Error('FastAction Profile Update Failed'),
            properties: {
              ErrorType: 'FastAction Profile Update Failed',
              Errors: response.errors,
              RawResponse: response.rawResponse,
              HttpStatus: response.httpStatus,
              FastActionSessionId: model.get('fastActionSessionId')
            }
          });
        });
    } else {
      user.createProfileAfterSubmission(request)
        .fail(function(model, response) {
          telemetry.trackException({
            exception: new Error('FastAction Profile Creation Failed'),
            properties: {
              ErrorType: 'FastAction Profile Creation Failed',
              Errors: response.errors,
              RawResponse: response.rawResponse,
              HttpStatus: response.httpStatus,
              FastActionSessionId: model.get('fastActionSessionId')
            }
          });
        });
    }

    return args;
  };

  FastAction.prototype.buildProfileDataFromForm = function (formData) {
    return {
      emailAddress: formData.Email || formData.EmailAddress,
      firstName: formData.FirstName,
      lastName: formData.LastName,
      addressLine1: formData.AddressLine1,
      addressLine2: formData.AddressLine2,
      city: formData.City,
      stateProvince: formData.StateProvince,
      postalCode: formData.PostalCode,
      mobilePhone: formData.MobilePhone || formData.Phone,
      homePhone: formData.HomePhone,
      employer: formData.Employer,
      occupation: formData.Occupation
    };
  };

  FastAction.prototype.buildPaymentDataFromOAResponseAndForm = function (oaResponse, postData) {
    if (!oaResponse) {
      return undefined;
    }

    const payment = {
      customerKey: oaResponse.customerKey,
      ccInfoKey: oaResponse.ccInfoKey,
      tokenPool: oaResponse.fastActionTokenPool,
      ccLastFour: oaResponse.cc4Digit,
      ccType: oaResponse.ccType
    };

    if (!Object.values(payment).every((v) => typeof v === 'string')) {
      return undefined;
    }

    if (!postData) {
      return payment;
    }

    const panAlias = postData.RedactedAccount;
    const expMonth = postData.ExpirationMonth;
    const expYear = postData.ExpirationYear;

    if (expMonth !== null && expMonth !== undefined && expYear !== null && expYear !== undefined) {
      const mDigits = String(expMonth).replace(/\D/g, '');
      const yDigits = String(expYear).replace(/\D/g, '');
      const monthNum = parseInt(mDigits, 10);
      if (Number.isFinite(monthNum) && monthNum >= 1 && monthNum <= 12 && yDigits.length >= 2) {
        payment.ccExpirationMonth = String(monthNum).padStart(2, '0');
        payment.ccExpirationYear = yDigits.length === 4 ? yDigits : '20' + yDigits.slice(-2);
      }
    }

    if (panAlias !== null && panAlias !== undefined) {
      try {
        const vgsPanAlias = window.btoa(JSON.stringify({vgsPanAlias: panAlias}));
        const vgsFallbackId = user.getVgsFallbackIdIfPanAliasMatches(vgsPanAlias);
        if (vgsFallbackId !== null && vgsFallbackId !== undefined) {
          payment.vgsFallbackId = vgsFallbackId;
        } else {
          payment.vgsPanAlias = vgsPanAlias;
        }
      } catch (e) {
        return payment;
      }
    }

    return payment;
  };

  FastAction.prototype.buildTransactionDataFromOAResponse = function (oaResponse, formdef) {
    // Extract transaction info from OA response and form definition
    if (!oaResponse || !oaResponse.confirmationID || !oaResponse.contributionAmount || !formdef?.designation?.name) {
      return undefined;
    }

    return {
      id: oaResponse.confirmationID,
      amount: parseFloat(oaResponse.contributionAmount),
      recipient: formdef.designation.name,
    };
  };

  FastAction.prototype.segue = function (args) {
    // Are any of the forms in the current chain fastAction forms?
    var fastAction = !kiosk && _.find(args.formviews, function (form) {
      return form.model.has('fastAction') && form.model.get('fastAction');
    });

    var form = args.formviews.current;
    var resources = form.options.form_definition.resources;

    if (fastAction) {
      var text = {
        AutofillQuickly: resources.fill(resources.PrimaryResources.AutofillQuickly, fastActionHtml),
        SingleClick: resources.fill(resources.PrimaryResources.SingleClick, '<br>')
      };

      var nologinSetting = args.thank && nologin && updateMyProfile;

      const faUrl = fastactionConfig.urls.base();
      args.calling_tag.$el.find('.fastaction-modal').remove();

      args.calling_tag.$el.append(templates.fa_modal({
        isSignup: true,
        nologin: nologinSetting,
        faBaseUrl: faUrl,
        fastactionRoute: 'SIGNUP',
        prefix: 'signup',
        other: 'login',
        text: _.extend({
          StoredOnThisDevice: resources.PrimaryResources.StoredOnThisDevice,
          SignUpForAnAccount: resources.fill(resources.PrimaryResources.SignupForAnAccount, fastActionHtml),
          ActionText: nologinSetting ? resources.PrimaryResources.SignUpNow : resources.PrimaryResources.SignUpWithYourEmail,
          OrBlankUsing: resources.fill(resources.PrimaryResources.OrBlankUsing,
            resources.PrimaryResources.SignUp.toLowerCase()),
          OtherOptionText: resources.fill(resources.PrimaryResources.AlreadyHaveFastAction, fastActionHtml),
          ByClickingAgree: resources.fill(resources.PrimaryResources.ByClickingAgree,
            resources.PrimaryResources.LogIn, fastActionHtml)
        }, text),
        resources: resources
      })).append(templates.fa_modal({
        faBaseUrl: faUrl,
        fastactionRoute: 'LOGIN',
        prefix: 'login',
        other: 'signup',
        text: _.extend({
          ActionText: resources.PrimaryResources.LogInWithYourEmail,
          OrBlankUsing: resources.fill(resources.PrimaryResources.OrBlankUsing,
            resources.PrimaryResources.LogIn.toLowerCase()),
          OtherOptionText: resources.fill(resources.PrimaryResources.DontHaveFastAction, fastActionHtml),
          ByClickingAgree: resources.fill(resources.PrimaryResources.ByClickingAgree,
            resources.PrimaryResources.SignUp, fastActionHtml),
        }, text),
        resources: resources
      })).append(templates.fa_modal({
        isSignup: true,
        nologin: nologinSetting,
        faBaseUrl: faUrl,
        fastactionRoute: 'COMPLETE_ACCOUNT_SIGNUP',
        prefix: 'signup-hustle',
        other: 'login-hustle',
        text: _.extend({
          StoredOnThisDevice: resources.PrimaryResources.StoredOnThisDevice,
          SignUpForAnAccount: resources.fill(resources.PrimaryResources.SignupForAnAccount, fastActionHtml),
          ActionText: nologinSetting ? resources.PrimaryResources.SignUpNow : resources.PrimaryResources.SignUpWithYourEmail,
          OrBlankUsing: resources.fill(resources.PrimaryResources.OrBlankUsing,
            resources.PrimaryResources.SignUp.toLowerCase()),
          OtherOptionText: resources.fill(resources.PrimaryResources.AlreadyHaveFastAction, fastActionHtml),
          ByClickingAgree: resources.fill(resources.PrimaryResources.ByClickingAgree,
            resources.PrimaryResources.LogIn, fastActionHtml)
        }, text),
        resources: resources
      })).append(templates.fa_modal({
        faBaseUrl: faUrl,
        fastactionRoute: 'LOGIN_AFTER_SUBMISSION',
        prefix: 'login-hustle',
        other: 'signup-hustle',
        text: _.extend({
          ActionText: resources.PrimaryResources.LogInWithYourEmail,
          OrBlankUsing: resources.fill(resources.PrimaryResources.OrBlankUsing,
            resources.PrimaryResources.LogIn.toLowerCase()),
          OtherOptionText: resources.fill(resources.PrimaryResources.DontHaveFastAction, fastActionHtml),
          ByClickingAgree: resources.fill(resources.PrimaryResources.ByClickingAgree,
            resources.PrimaryResources.SignUp, fastActionHtml),
        }, text),
        resources: resources
      }));
    }

    if (cookieConsentConfig.areFunctionalCookiesAccepted()) {
      authPopups(user.get('fastActionSessionId'));
    }

    const hasAsked = userView && userView.asked;
    var shouldAsk = args.thank || !(form.isFirstForm() || hasPayment(form.model.get('form_elements')));

    if (fastAction && cookieConsentConfig.areFunctionalCookiesAccepted() && updateMyProfile && (!loggedIn || !user.get('authed')) && !hasAsked && shouldAsk) {
      // Fire up the hustle modal
      window.location.hash = 'fastaction-signup-hustle';
      userView.asked = true;
    }
  };

  FastAction.prototype.onSubmit = function (args) {
    var checkUpdateMyProfileInputs = args.currentTarget
      ? $(args.currentTarget).find('input[name="updateMyProfile"]:checked')
      : args.formview.$('input[name="updateMyProfile"]:checked');

    var isOrgMode = args.formview && args.formview.contactMode === 'org';
    updateMyProfile = !isOrgMode && checkUpdateMyProfileInputs.length > 0;
    return args;
  };

  FastAction.prototype.alterPost = function (args) {
    // Detect if we're past step one of a multistep advocacy form,
    // and treat it like a form without fastaction enabled - don't post on form submit.
    // You should also not alter the post if the form is in consent mode and the supporter has not consented.
    if (isNotEnabled() || args.form_definition.hideUpdateMyFastActionProfile ||
      !cookieConsentConfig.areFunctionalCookiesAccepted()) {
      return args;
    }

    if (updateMyProfile) {
      if (nologin && !loggedIn) {
        args.data.autoCreateAccount = 'true';
      } else if (loggedIn) {
        args.data.updateProfile = 'true';
      }
    } else {
      args.data.ignorePaymentInfo = 'true';
    }

    if (user.get('id')) {
      args.data.fastActionId = user.get('id');
    }

    if (user.get('fastActionSessionId')) {
      args.data.fastActionSessionId = user.get('fastActionSessionId');
    }

    // Include the endpoint for reference/logging
    args.data.endpoint = args.endpoint;

    // If autoprocess data exists, add it to the form submission
    if (autoProcessPostData) {
      args.data.autoProcessToken = autoProcessPostData.token;
      args.data.qs = JSON.stringify(autoProcessPostData.qs);
      autoProcessPostData = null;
    }

    return args;
  };

  FastAction.prototype.user = function () {
    return user;
  };

  return FastAction;
})();

export default new FastAction();
